import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDZYmeWu7c77PvkAc5uoFO4yH67GFweV5s",
  authDomain: "waste-free-tahoe-app.firebaseapp.com",
  projectId: "waste-free-tahoe-app",
  storageBucket: "waste-free-tahoe-app.firebasestorage.app",
  messagingSenderId: "989451780037",
  appId: "1:989451780037:web:8a91382c3ab11abdacd5ac"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
